module.exports = __webpack_public_path__ + "static/media/warn.bc356e32.svg";